/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllowEditResponseDTO
 */
export interface AllowEditResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof AllowEditResponseDTO
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowEditResponseDTO
     */
    allowNew?: boolean;
}

/**
 * Check if a given object implements the AllowEditResponseDTO interface.
 */
export function instanceOfAllowEditResponseDTO(value: object): value is AllowEditResponseDTO {
    return true;
}

export function AllowEditResponseDTOFromJSON(json: any): AllowEditResponseDTO {
    return AllowEditResponseDTOFromJSONTyped(json, false);
}

export function AllowEditResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowEditResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'allowEdit': json['allowEdit'] == null ? undefined : json['allowEdit'],
        'allowNew': json['allowNew'] == null ? undefined : json['allowNew'],
    };
}

export function AllowEditResponseDTOToJSON(json: any): AllowEditResponseDTO {
    return AllowEditResponseDTOToJSONTyped(json, false);
}

export function AllowEditResponseDTOToJSONTyped(value?: AllowEditResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowEdit': value['allowEdit'],
        'allowNew': value['allowNew'],
    };
}

